import UIDs from "../../../../UIDs";

const uid = UIDs.screens.learn.commentlist;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,

    SEARCH_COMMENTS_ASYNC: `${uid}.searchCommentsAsync`,
    SEARCH_COMMENTS_SUCCESS: `${uid}.searchCommentsSuccess`,
    SEARCH_COMMENTS_FAILURE: `${uid}.searchCommentsFailure`,

    REFRESH_SCREEN_ASYNC: `${uid}.refreshScreenAsync`,
    REFRESH_SCREEN_SUCCESS: `${uid}.refreshScreenSuccess`,
    REFRESH_SCREEN_FAILURE: `${uid}.refreshScreenFailure`,

    REMOVE_COMMENT_ASYNC: `${uid}.removeCommentAsync`,
    REMOVE_COMMENT_SUCCESS: `${uid}.removeCommentSuccess`,
    REMOVE_COMMENT_FAILURE: `${uid}.removeCommentFailure`,

    ADD_COMMENT_LIKE_ASYNC: `${uid}.addCommentLikeAsync`,
    ADD_COMMENT_LIKE_SUCCESS: `${uid}.addCommentLikeSuccess`,
    ADD_COMMENT_LIKE_FAILURE: `${uid}.addCommentLikeFailure`,

    REMOVE_COMMENT_LIKE_ASYNC: `${uid}.removeCommentLikeAsync`,
    REMOVE_COMMENT_LIKE_SUCCESS: `${uid}.removeCommentLikeSuccess`,
    REMOVE_COMMENT_LIKE_FAILURE: `${uid}.removeCommentLikeFailure`,

    CHANGE_SEARCH_STATE: `${uid}.changeSearchState`,
};

export { ActionTypes };